import { pathOr } from 'ramda'
import { createSelector } from 'reselect'

import { access } from '@driftt/traffic-control'

import { FEATURES_FOR_PAGE, ReportPage } from 'types/pages'
import { rootSelector } from 'utils/redux'

export const getOrgWorkspaces = pathOr({}, ['workspaces', 'workspace'])
export const cutovers = rootSelector('cutovers')

export const createGetWorkspaceOptions = (reportPage: ReportPage) =>
  createSelector(getOrgWorkspaces, (orgWorkspaces) => {
    const featuresForPage = FEATURES_FOR_PAGE[reportPage]
    const workspacesWithReportRead = featuresForPage.flatMap((feature) =>
      access.getWorkspacesWithPermission(feature, 'READ')
    )
    const workspacesWithReportReadDeDuped = [
      ...new Set(workspacesWithReportRead),
    ]
    return workspacesWithReportReadDeDuped.map((id) => ({
      label: orgWorkspaces[id]?.name ?? 'Unknown workspace',
      value: id,
    }))
  })
